<template>
  <base-dialog :visible.sync="visible" show-close append-to-body>
    <template v-slot:header>编辑项目</template>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="名称">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="form.templateDesc"></el-input>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"

export default {
  name: "EditProjectDialog",
  props: {
    projectInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    BaseDialog
  },
  data() {
    return {
      visible: false,
      form: {
        name: null,
        templateDesc: null
      }
    }
  },
  methods: {
    open() {
      this.form = Object.assign(this.form, this._.cloneDeep(this.projectInfo))
      this.visible = true
    },
    submit() {
      this.$emit("submit", this.form)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  padding-top: 22px;
}
</style>
